import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { allIcons } from "../../assets";
import Label from "../Label";
import SelectInput from "../SelectInput";
import GlobalButton from "../CustomButton";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "500px",
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      margin: 12,
    },
  },
  "& .MuiDialogContent-root": {
    padding: "0 0",
    [theme.breakpoints.down("sm")]: {
      padding: "0 8px",
    },
  },
}));

const cities = [
  { label: "9 Cut barber shop", value: "9 Cut barber shop" },
  { label: "Saminaz salon", value: "Saminaz salon" },
  { label: "Anna salon", value: "Anna salon" },
];
const service = [
  { label: "Hair & Styling", value: "Hair & Styling" },
  { label: "Nail", value: "Nail" },
  { label: "Fashial and skin care", value: "Fashial and skin care" },
];
const status = [
  { label: "Accepted", value: "Accepted" },
  { label: "New", value: "New" },
  { label: "Completed", value: "Completed" },
];

let paramsData = {};

const CategoryServiceFilterDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <Stack direction={"row"} justifyContent={"space-between"}>
        <DialogTitle sx={{ m: 0, p: 0 }} id="customized-dialog-title">
          Filters
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label labelText="Business Owner" />
            <SelectInput
              icon={
                <img
                  src={allIcons.boundyBoxIcon}
                  alt={"city-icon"}
                  width={20}
                />
              }
              options={cities}
            />
          </Grid>
          <Grid item xs={12}>
            <Label labelText="category" />
            <SelectInput
              icon={
                <img
                  src={allIcons.briefcaseIcon}
                  alt={"city-icon"}
                  width={20}
                />
              }
              options={service}
            />
          </Grid>
        </Grid>
        <Typography
          my={1}
          variant="body2"
          display={"inline-block"}
          sx={{ cursor: "pointer" }}
        >
          Clear all filters
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"cancel"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleClose}
        />
        <GlobalButton
          variant={"contained"}
          btnText={"Yes"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleClose}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default CategoryServiceFilterDialog;
